import { React, useState, useEffect } from 'react';
import { Form, Button, Stack, Card, Container, Row, Col, Modal, Alert } from 'react-bootstrap';
import { EventList } from './EventList/EventList';
import * as api from 'services/api';
import { useUserContext } from 'contexts/UserContext';
import { useTranslation } from 'react-i18next';
import { Map } from '../../../components/Map/Map';
import { format } from 'date-fns';

export function EquipmentDetails({ equipmentData, setDisableCleanButt, interventionType, newPhoneNumber }) {
    const { t } = useTranslation();
    const { userData } = useUserContext();
    const [blockedMinutes, setBlockedMinutes] = useState(5);
    const [lockMessages, setLockMessages] = useState({
        locked: [],
        alreadyLocked: [],
        error: []
    });
    const [lastLocation, setLastLocation] = useState({
        longitude: 0,
        latitude: 0,
        arrivalTime: '',
        phone: ''
    });
    const [unlockMessages, setUnlockMessages] = useState([]);
    const [callHistory, setCallHistory] = useState([]);
    const [checked, setChecked] = useState(false);
    const [overrideCodes, setOverrideCodes] = useState([]);
    const [overrideCodeId, setOverrideCodeId] = useState(0);
    const [pseudoCodeId, setPseudoCodeId] = useState(0);
    const [lockDateTime, setLockDateTime] = useState('');
    const [isNewLocation, setIsNewLocation] = useState(false);
    const [equipmentBlockingTime, setEquipmentBlockingTime] = useState([]);
    const [error, setError] = useState(null);
    const [disabledCheckButt, setDisabledCheckButt] = useState(false);
    const [lastLocationTime, setLastLocationTime] = useState('');
    const [disabledPseudoSelect, setDisabledPseudoSelect] = useState(false);
    const [disabledFinishButt, setDisabledFinishButt] = useState(false);
    const [defaultPseudoSelected, setDefaultPseudoSelected] = useState('');
    const [selectedCodes, setSelectedCodes] = useState([]);
    const [checkTime, setCheckTime] = useState(null);
    const [lockTime, setLockTime] = useState(null);
    const [lockedData, setLockedData] = useState({
        epecLocationId: equipmentData.epecLocationId,
        equipmentIdent: equipmentData.equipmentIdent,
        blockedMinutes: 5,
        pseudoCodeOverridesPairs: []
    });
    const [requestPseudocodes, setRequestPseudocodes] = useState([]);
    const [integrationData, setIntegrationData] = useState({
        username: userData.username,
        dwellingId: equipmentData.equipmentIdent,
        action: interventionType.integrationId,
        pseudocodes: requestPseudocodes
    });
    const [showModal, setShowModal] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    //#endregion

    //#region ------------------------------------------------ EFFECTS --------------------
    const hasLockMessages = lockMessages.locked.length > 0 || lockMessages.alreadyLocked.length > 0 || lockMessages.error.length > 0;
    const hasUnlockMessages = unlockMessages.length > 0;
    const showFinish = checked && hasLockMessages;
    const [interventionTypes, setInterventionTypes] = useState([]);
    const [interventionData, setInterventionData] = useState({
        id: 0,
        userId: userData.personId,
        interventionTypeId: interventionType.id,
        niu: equipmentData.equipmentIdent,
        pseudoCodeOverridesPairs: [],
        integrationId: 0,
        lockMinutes: blockedMinutes
    });
    

    useEffect(() => {
        const fetchConfig = async () => {
            const controlCentrePseudoCodes = await api.getControlCentreConfigs(userData.controlCentreId);
            if (controlCentrePseudoCodes.status === 200) {
                const selectedPseudoCodesByInterventionType = controlCentrePseudoCodes.data.filter(pseudoCode => pseudoCode.interventionType === interventionType.id);
                if (selectedPseudoCodesByInterventionType.length === 0) {
                    setError(t('it.NoPseudoCodeForThisInterventionType'));
                    return;
                }
                setOverrideCodes(selectedPseudoCodesByInterventionType);
                if (controlCentrePseudoCodes.data.length === 0) {
                    setError(t('noPseudocodesAssociatedYourControlCentre'));
                } else {
                    const defaultPseudo = selectedPseudoCodesByInterventionType[0].pseudoCodeId + '-' + selectedPseudoCodesByInterventionType[0].overrideCodeId;
                    setDefaultPseudoSelected(defaultPseudo);
                }
            } else {
                console.log('FAILED RECOVERING CONFIGS');
                setError(t('noControlCenterSettingRetrieve'));
            }
        };

        setError("");
        setOverrideCodes([]);

        fetchConfig();

    }, [userData.controlCentreId, interventionType]);

    useEffect(() => {
        setDefaultPseudoConfig(defaultPseudoSelected)
    }, [defaultPseudoSelected])

    const registerPseudoCodeChecked = async (requestPseudocodes) => {
        const registerPseudoCodeChecked = await api.registerPseudoCodeChecked(interventionData.id, requestPseudocodes);
        console.log(registerPseudoCodeChecked);
    }

    useEffect(() => {
        console.log(requestPseudocodes);
        registerPseudoCodeChecked(requestPseudocodes);
    }, [requestPseudocodes])
    //#endregion

    //#region ------------------------------------------------- HANDLERS ------------------
    const setDefaultPseudoConfig = (pseudos) => {
        const pseudoid = parseInt(pseudos.split('-')[0])
        setPseudoCodeId(pseudoid);
        const overrideid = parseInt(pseudos.split('-')[1])
        setOverrideCodeId(overrideid);
        if (overrideCodes.length > 0) {
            const combinedTimes = [
                ...new Set(
                    overrideCodes.flatMap(override => override.blockingTimeSet).filter(time => time !== 0)
                ),
            ].sort((a, b) => a - b);

            setEquipmentBlockingTime(combinedTimes)
            setBlockedMinutes(combinedTimes[0]);
            setLockedData({
                ...lockedData,
                blockedMinutes: combinedTimes[0]
            })
        }
    }

    const handleTimeChange = (event) => {
        setBlockedMinutes(event.target.value);
        setLockedData({
            ...lockedData,
            blockedMinutes: event.target.value
        });

    };

    const handleBlock = async (event) => {
        event.preventDefault();
        setDisableCleanButt(true);
        setDisabledPseudoSelect(true);
        setLockTime(new Date().toLocaleTimeString());

        setLockDateTime(new Date());

        const insertResponse = await api.insertPseudoCode(lockedData);

        setLockMessages({
            locked: insertResponse.data.locked,
            alreadyLocked: insertResponse.data.alreadyLocked,
            error: insertResponse.data.error
        });

        const interventionPayload = ({
            ...interventionData,
            lockMinutes: lockedData.blockedMinutes
        });
        const insertInterventionResponse = await api.insertIntervention(interventionPayload);

        setInterventionData({
            ...interventionData,
            id: insertInterventionResponse.data.id
        });
    };

    const handleFindOut = async () => {

        const response = await api.getCallHistory(equipmentData.equipmentIdent);

        if (response.status === 200) {
            setCallHistory(response.data)
            setChecked(true);
            setCheckTime(new Date().toLocaleTimeString());
        } else {
            console.error(t('errorObtainingHistory'));
        }

        if (interventionType.checkLocation === true) handleLastLocation();

    };

    const handleCheckAndFinish = () => {
        if (requestPseudocodes.length === 0) {
            setShowModal(true); // Mostrar el modal
            return;
        } else if (interventionType.checkLocation === true && !isNewLocation) {
            setShowModal(true);
            return;
        }
        
        handleFinish(); // Ejecutar directamente si hay elementos
        
    };

    const handleFinish = async () => {

        setDisabledCheckButt(true);
        setDisabledFinishButt(true);

        const response = await api.deletePseudoCode(lockedData);
        if (response.status === 200) {
            setUnlockMessages((messages) => [...messages, response.data.message]);

            const dataToSend = {
                ...integrationData,
                pseudocodes: requestPseudocodes,
                interventionId: interventionData.id
            };

            if (requestPseudocodes.length > 0) {

                const responseÍntegration = await api.integration(dataToSend);

                if (responseÍntegration.status === 200) {
                    console.log(t('integrationSuccess'));
                    setInterventionData({
                        ...interventionData,
                        integrationId: responseÍntegration.data.Id
                    });
                } else {
                    console.log(t('integrationError'));
                }
            }
            await api.endIntervention(interventionData);
        }
        
        setDisableCleanButt(false);

    };

    const handleClose = () => {
        window.location.reload();
    };

    const handleChange = (event) => {
        const { value, checked } = event.target;
        let updatedCodes = [...selectedCodes];

        const changedCode = overrideCodes.find(code => code.pseudoCodeId === parseInt(value.split('-')[0]) && code.overrideCodeId === parseInt(value.split('-')[1]));

        if (checked) {
                setIntegrationData({
                    ...integrationData,
                    action: changedCode.interventionType
                })

            updatedCodes.push(value);
        } else {

            updatedCodes = updatedCodes.filter(code => code !== value);
        }
        setSelectedCodes(updatedCodes);
        setLockedData({
            ...lockedData,
            pseudoCodeOverridesPairs: updatedCodes
        })

        setInterventionData({
            ...interventionData,
            pseudoCodeOverridesPairs: updatedCodes
        })
    }

    const handleLastLocation = async () => {

        const response = await api.getLastLocation(newPhoneNumber);

        if (response.status === 200) {
            setLastLocationTime(format(new Date(response.data.arrivalTime), "dd/MM/yyyy HH:mm"));
            if (new Date(response.data.arrivalTime) > lockDateTime) setIsNewLocation(true);
            setLastLocation(response.data);
        } else {
            console.error(t('errorObtainingHistory'));
        }
    };

    //#endregion

    return (
        <Form>
            <Container>
                {error && (
                    <Alert className="EquipmentDetails mt-3 p-4" variant="warning">
                        {error}
                    </Alert>

                )}
            </Container>

            {overrideCodes.length > 0 && (
                <>
                    <Card className="EquipmentDetails mt-3 p-4">
                        <Card.Title>{t('pseudocodes')}</Card.Title>
                        <Stack direction="horizontal" gap={3}>

                            <Form.Group className="bg-light p-2" disabled={disabledPseudoSelect}>
                                <Form.Label>{t('selectPseudocodeOrigin')}</Form.Label>
                                {overrideCodes.map(code => (
                                    <Form.Check
                                        key={code.controlCentreConfigId}
                                        type="checkbox"
                                        label={`${code.pseudoCodeId}:${code.pseudoCodeText}  ➡ ${code.overrideCodeId}:${code.overrideCodeText}`}
                                        value={`${code.pseudoCodeId}-${code.overrideCodeId}`}
                                        checked={selectedCodes.includes(`${code.pseudoCodeId}-${code.overrideCodeId}`)}
                                        onChange={handleChange}
                                        disabled={disabledPseudoSelect}
                                    />
                                ))}
                            </Form.Group>
                        </Stack>
                    </Card>
                    <Card className="EquipmentDetails mt-3 p-4">

                        <Card.Title className='mb-3'>{t('locking')}{lockTime && (<small>&nbsp;&nbsp;<b>{lockTime}</b> ({blockedMinutes}&nbsp;{t('minutes')})</small>)}</Card.Title>

                        {hasLockMessages ? (
                            <div>
                                <div className="flex-grow-1">
                                    {lockMessages.locked.map((message, index) => (
                                        <div key={index}>
                                            <img src="./icons/lockIcon.svg" alt="lock" className="mr-2" />
                                            <small className="text-muted mx-1" key={index}>{message}</small>
                                        </div>
                                    ))}
                                </div><br></br>
                                <div className="flex-grow-2">
                                    {lockMessages.alreadyLocked.map((message, index) => (
                                        <div key={index}>
                                            <small><b>{t('alreadyLocked')}: </b></small>
                                            <small className="text-muted mx-1" key={index}>{message}</small>
                                        </div>
                                    ))}
                                </div><br></br>
                                <div className="flex-grow-3">
                                    {lockMessages.error.map((message, index) => (
                                        <div key={index}>
                                            <small><b>{t('error')}: </b></small>
                                            <small className="text-muted mx-1" key={index}>{message}</small>
                                        </div>
                                    ))}
                                </div><br></br>
                                <Row>
                                    <Col>
                                        <Button disabled={disabledCheckButt}
                                            variant={showFinish ? 'outline-dark' : 'dark'}
                                            onClick={handleFindOut}>
                                            {t('check')}
                                        </Button>
                                    </Col>
                                    
                                    {checkTime && (
                                        <Col>
                                            <div style={{ marginTop: '1em', textAlign: 'right', fontWeight: 'bold' }}>
                                                <small>{t('checkTime')}{checkTime}</small>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                            </div>
                        ) : (
                            <Stack direction="horizontal" gap={3} >
                                <Form.Select className="bg-light" onChange={handleTimeChange}>
                                    {equipmentBlockingTime.map(time => (
                                        <option key={time} value={time}>
                                            {`${time} ${t('minutes')}`}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Button
                                    type="submit"
                                    variant="dark"
                                    onClick={(event) => handleBlock(event)}
                                    disabled={hasLockMessages || selectedCodes.length === 0}>
                                    {t('lock')}
                                </Button>
                            </Stack >
                        )}

                        {showFinish && (<>
                            <Stack direction="horizontal" gap={3} className="align-items-end mt-3">
                                <div className="flex-grow-1">
                                    <EventList equipmentIdent={equipmentData.equipmentIdent} callHistory={callHistory} setRequestPseudocodes={setRequestPseudocodes} overridesPairs={lockedData.pseudoCodeOverridesPairs} />
                                </div>

                            </Stack>

                            {interventionType.checkLocation === true && (
                                <>
                                    {lastLocation.latitude !== 0 ? (
                                        <Row>
                                            <Col>
                                                <div style={{ marginTop: '1em', textAlign: 'right', fontWeight: 'bold' }}>
                                                    <small style={{ color: isNewLocation ? 'green' : 'red' }} >{t('md.lastPositionArrived')}: {lastLocationTime}</small>
                                                </div>
                                                <Map data={lastLocation} />
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Alert className="EquipmentDetails mt-3 p-2" variant="warning">
                                            {t('md.noLocations')}
                                        </Alert>
                            
                                    )}
                                </>
                            )}
                            <Stack direction="horizontal" gap={3} className="align-items-end mt-3">
                                <div className="flex-grow-1">
                                    <Button variant="dark" onClick={handleCheckAndFinish} disabled={disabledFinishButt}>
                                        {t('end')}
                                    </Button>
                                </div>
                            </Stack>
                        </>
                        )}

                        {hasUnlockMessages && (
                            <div className="mt-3">
                                <div>
                                    {unlockMessages.map((message, index) => (
                                        <div key={index}>
                                            <img src="./icons/unlockIcon.svg" alt="lock" className="mr-2" />
                                            <small className="text-muted mx-1" key={index}>{t('unlocked')} {message}</small>
                                        </div>
                                    ))}
                                </div>
                                <Button variant="dark" className="mt-3" onClick={handleClose}>{t('close')}</Button>
                            </div>
                        )}
                    </Card>
                </>
            )}

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('warning')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {requestPseudocodes.length === 0 && (
                        <p>{t('noValidationMessagePNC')}</p>
                    )}

                    {(interventionType.checkLocation === true && !isNewLocation) && (
                        <p>{t('noValidationLastLocation')}</p>
                    )}     
                    <ul>
                        <li><b>{t('usAccept')}:</b> {t('acceptWithoutValid')}</li>
                        <li><b>{t('usCancel')}:</b> {t('cancelOtherSilentCall')}</li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)} className="me-auto">
                        {t('usCancel')}
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShowModal(false);
                        handleFinish(); // Ejecutar la función incluso si el array está vacío
                    }}>
                        {t('usAccept')}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showAlertModal} onHide={() => setShowAlertModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('error')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t('pseudocodeDifferentIntervention')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => {
                        setShowAlertModal(false);
                    }}>
                        {t('usAccept')}
                    </Button>
                </Modal.Footer>
            </Modal>

        </Form>
    );
}